<template>
  <div class="invest">
    <div class="head  pl40 pr40">
      <div class="pt112 c-o f48 lh66 fw800 ">
          {{ t("how_the_gold.title") }}
      </div>
      <div class="pt14 f28 lh40 c-o">{{ t("how_the_gold.title1") }}</div>
    </div>
    <div class="cont ml40 mr40  bg-f mb48">
      <div class="pt60 pb72 flex ac lh50 c-0 f36 ">
        <span class="titleIco"></span>
        <p class="ml16 fw600">{{ t("how_the_gold.title2") }}</p>
      </div>
      <ul class="pl40 pr40 pb10 introUl">
        <li class="pb80" v-for="(item, index) in icos" :key="index">
          <div class="flex ac pb32" :class="getClass().lineHeightClass">
            <img class="listSetp  mr18" :src="item.step" alt="">
            <p class="f36 c-0 fw500">{{t(`how_the_gold.ul.li${index+1}.t1`)}}</p>
          </div>
          <div class="flex ac introBg pt32 pb50 pr46" :class="lang.getLang()==='zh-EN'?'':item.class">
            <img class="listIco ml42 mr50" :src="item.ico" alt="">
            <p class="f28 c-3 lh40">{{t(`how_the_gold.ul.li${index+1}.t2`)}}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive,toRefs } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import lang from '@/lang/utils'
import ico1 from '@/assets/images/how-the-gold/ico1.png'
import ico2 from '@/assets/images/how-the-gold/ico2.png'
import ico3 from '@/assets/images/how-the-gold/ico3.png'
import step1 from '@/assets/images/how-the-gold/step1.png'
import step2 from '@/assets/images/how-the-gold/step2.png'
import step3 from '@/assets/images/how-the-gold/step3.png'


export default {
  name: "HowTheGold",
  setup() {
    const route = useRoute();
    const { t } = useI18n();
    const state = reactive({
      icos:[
        {
          ico:ico1,
          step:step1,
          class:''
        },
        {
          ico:ico2,
          step:step2,
          class:'introBg2'
        },
        {
          ico:ico3,
          step:step3,
          class:''
        }
      ]
    });
    const getClass = () =>{
      let titleClass,lineHeightClass
      switch (lang.getLang()) {
        case 'zh-CN':
          titleClass = 'w240'
          break;
        case 'zh-EN':
          titleClass = 'w400'
          break;
        default:
          titleClass = 'w240'
          break;
      }
      return {
        titleClass,
        lineHeightClass
      }
    }
    const getType = ()=>{
      console.log(route.params.type)
      return route.params.type
    }
    onMounted(() => {
      document.title = t("how_the_gold.title");
    });

    return {
      ...toRefs(state),
      t,
      getClass,
      getType,
      lang
    };
  },
};
</script>

<style lang="stylus" scoped>
@import './style.styl';
</style>